import { Check } from 'lucide-react';
import { RadioGroup } from 'radix-ui';
import { useReadOnly } from './read-only-context';

export interface ColorSwatchesProps {
  value: number;
  count: number;
  onChange: (slot: number) => void;
  label: string;
  swatchLabel: (slot: number) => string;
  id?: string;
}

/** Categorical colour picker over the chart palette slots (`--chart-series-N`). */
export function ColorSwatches({
  value,
  count,
  onChange,
  label,
  swatchLabel,
  id,
}: ColorSwatchesProps) {
  const readOnly = useReadOnly();
  return (
    <RadioGroup.Root
      id={id}
      aria-label={label}
      value={String(value)}
      onValueChange={(v) => {
        onChange(Number(v));
      }}
      orientation="horizontal"
      className="flex flex-wrap gap-1.5 pt-1"
    >
      {Array.from({ length: count }, (_, slot) => (
        <RadioGroup.Item
          key={slot}
          value={String(slot)}
          aria-label={swatchLabel(slot)}
          disabled={readOnly && slot !== value}
          className="flex size-5 items-center justify-center rounded-full outline-none ring-offset-2 ring-offset-bg-1 focus-visible:ring-2 focus-visible:ring-focus disabled:opacity-40"
          style={{ background: `var(--chart-series-${String(slot + 1)})` }}
        >
          <RadioGroup.Indicator>
            <Check className="size-3 text-white" strokeWidth={3} />
          </RadioGroup.Indicator>
        </RadioGroup.Item>
      ))}
    </RadioGroup.Root>
  );
}
